import { initGlobalState } from 'qiankun';
import router from '../router'

const goDocPreview = () => {
  let routeData = router.resolve({
    path: "/child-contentCenter/valueDelivery/docPreviewV2",
  });
  window.open(routeData.href, "_blank");
}

export const state = {
  goDocPreview,
  origin: "boss"
}
// 初始化 state
const actions = initGlobalState(state);

// actions.onGlobalStateChange((state, prev) => {
//   // state: 变更后的状态; prev 变更前的状态
//   console.log(state, prev);
// });
// actions.setGlobalState(state);
// actions.offGlobalStateChange();

export default actions;